import styled from '@emotion/styled';
import { GUTTER_SPACING } from '../../constants';
import { mobileOnly, desktopOnly } from '../../utils/sharedStyles';

export const koreaLegalFooterDivider = 'korea-legal-footer-divider';
export const noLegalFooterSpacer = 'no-legal-footer-spacer';
export const minimalFooterClass = 'minimal-footer';
export const StyledFooter = styled.footer`
  width: 100%;
  background: var(--podium-cds-color-bg-primary);
  min-height: 300px;
  max-width: 1920px;
  margin: auto;

  @media (${mobileOnly}) {
    padding: 48px 24px;
  }

  @media (${desktopOnly}) {
    padding: ${GUTTER_SPACING}px;
  }

  .${koreaLegalFooterDivider} {
    margin: 24px 0;
  }

  &.${minimalFooterClass} {
    .footer-menu-column,
    .mobile-footer-accordion {
      display: none;
      visibility: hidden;
    }

    .footer-spacer {
      margin-bottom: 24px;
    }

    .language-tunnel {
      justify-content: normal;
    }
  }
`;

export const StyledFooterSpacer = styled.div`
  margin-bottom: 24px;

  @media (${desktopOnly}) {
    margin-bottom: 72px;
  }
`;

export const StyledHorizontalBar = styled.div`
  height: 1px;
  flex-shrink: 0;
  background: var(--podium-cds-color-border-tertiary);
  margin-bottom: 36px;
  @media (${desktopOnly}) {
    margin-bottom: 60px;
    .${koreaLegalFooterDivider} {
      margin-bottom: 24px;
    }
  }
`;
